<template>
    <div class="query-service-panel">
        <custom-panel :title="title" :height="height" :hideMore="true" @moreClick="moreClickHandle">
            <template #content>
                <div class="service-list">
                    <div class="service-item" v-for="item in list" :key="item.id" @click="itemClickHandle(item)">
                        <div v-if="item.iconBase64 || item.iconUrl" class="service-icon dynamic-icon">
                            <img :src="item.iconBase64 || item.iconUrl" :alt="item.menuName || item.text" />
                        </div>
                        <div v-else :class="['service-icon', item.id]"></div>
                        <div class="service-name">{{ item.menuName }}</div>
                    </div>
                </div>
            </template>
        </custom-panel>
    </div>
</template>

<script>
import CustomPanel from '@/components/custom-panel.vue';
import { queryServiceMenus } from '@/common/api';

export default {
    props: {
        height: {
            type: Number
        }
    },

    components: {
        CustomPanel
    },

    data() {
        return {
            title: '查询服务',
            // list: [
            //     { id: 'process', name: '进度查询' },
            //     { id: 'report', name: '报告查询', path: '/query-service/report-query' },
            //     { id: 'cert', name: '证书查询' }
            // ]
            list: []
        };
    },

    methods: {
        moreClickHandle() {
            // console.log('more click');
        },

        async getServiceMenus() {
            try {
                const { data } = await queryServiceMenus('查询服务');
                if (Array.isArray(data)) {
                    this.list = data;
                }
            } catch (error) {
                console.error('获取查询服务菜单失败:', error);
            }
        },

        itemClickHandle(item) {
            const path = (item.route || item.path)?.trim();

            if (!path) {
                this.$message.warning('该功能暂未开放，敬请期待！');
            } else if (/^https?:\/\//i.test(path)) {
                window.open(path, item.id);
            } else if (path.startsWith('/')) {
                this.$router.push({ path });
            } else {
                this.$message.warning('该功能暂未开放，敬请期待！');
            }
        }
    },

    created() {
        this.getServiceMenus();
    }
};
</script>

<style lang="scss" scoped>
.query-service-panel {
    .service-list {
        height: 100%;
        overflow-y: auto;
        padding-right: 4px;
        display: flex;
        flex-direction: column;
        gap: 8px;

        .service-item {
            flex: 0 0 86px;
            height: 86px;
            padding: 0 20px;
            border-radius: 2px;
            background: #f0f4fb;
            border: 1px solid transparent;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            cursor: pointer;

            &:hover {
                border: 1px solid #b6c6eb;
            }

            .service-icon {
                width: 64px;
                height: 64px;

                &.dynamic-icon img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                }

                &.process {
                    background: url(../imgs/icon-process.png) no-repeat center;
                }

                &.report {
                    background: url(../imgs/icon-report.png) no-repeat center;
                }

                &.cert {
                    background: url(../imgs/icon-cert.png) no-repeat center;
                }
            }

            .service-name {
                flex: 1;
                font-size: 18px;
                text-align: center;
                color: #333333;
                letter-spacing: 1.8px;
                line-height: 20px;
                font-weight: 600;
            }
        }
    }
}
</style>
